import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Route, Switch, withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import qs from 'query-string';
import { setFullHeight } from '../../actions/uiActions';
import { clearTitleData } from '../../actions/titleActions';
import { loadContextualizedVideoData } from '../../actions/contextualizedVideoTitleActions';
import asyncComponent from '../../utils/async';
import { RedirectAs404 } from '../Error404';


const AsyncContextualizedVideo = asyncComponent(() => import('../ContextualizedVideo'));

class ContextualizedVideoTitle extends Component {
  UNSAFE_componentWillMount () { // eslint-disable-line camelcase
    const { breakpoint, actions, uid, name, slug, subtitle, description, media, itemGroups } = this.props;
    actions.loadContextualizedVideoData({ uid, name, slug, subtitle, description, media, itemGroups });
    actions.setFullHeight(breakpoint.greaterThanOrEqual.lg);
  }

  UNSAFE_componentWillReceiveProps (nextProps) { // eslint-disable-line camelcase
    const { actions, breakpoint } = nextProps;
    if (breakpoint.mediaType !== this.props.breakpoint.mediaType) {
      actions.setFullHeight(breakpoint.greaterThanOrEqual.lg);
    }
  }

  componentWillUnmount () {
    const { actions, uid } = this.props;
    actions.clearTitleData(uid);
  }

  parseActiveView (props) {
    const { location: { search } } = props;
    const val = qs.parse(search).focus;
    return val && ['video', 'context'].includes(val.toLowerCase()) ? val.toLowerCase() : null;
  }

  render () {
    const { match, titleData } = this.props;
    if (Object.keys(titleData).length === 0) {
      // TODO: loading animation
      return null;
    }
    const { itemsBySlug, itemGroups } = titleData;

    return (
      <div className="title-wrapper">
        <Switch>
          <Route exact path={match.url} render={props => {
            const firstSlug = itemGroups[0].items[0];
            return <AsyncContextualizedVideo firstSlug={firstSlug} baseUrl={match.url} {...titleData} />;
          }} />
          <Route exact path={`${match.url}/:itemSlug`} render={props => {
            const { itemSlug } = props.match.params;
            const activeView = this.parseActiveView(props);
            if (!itemsBySlug.hasOwnProperty(itemSlug)) {
              return <RedirectAs404 />;
            }
            return <AsyncContextualizedVideo activeItemSlug={itemSlug} activeView={activeView} baseUrl={match.url} {...titleData} />;
          }} />
          <Route component={RedirectAs404} />
        </Switch>
      </div>
    );
  }
}

ContextualizedVideoTitle.propTypes = {
  uid: PropTypes.string.isRequired,
  titleData: PropTypes.object,
};

ContextualizedVideoTitle.defaultProps = {
  titleData: {},
};

const mapStateToProps = ({ breakpoint, titles }, ownProps) => ({
  breakpoint,
  titleData: titles[ownProps.uid],
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ setFullHeight, clearTitleData, loadContextualizedVideoData }, dispatch),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ContextualizedVideoTitle));



// WEBPACK FOOTER //
// ./src/components/Title/ContextualizedVideoTitle.js